module.exports = __webpack_public_path__ + "img/shop.d857ec5b.png";